
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package } from "lucide-react";
import { useInventaire } from "@/hooks/useInventaire";

interface ArticlesCritiquesCardProps {
  selectedBateauId: string | null;
}

const ArticlesCritiquesCard = ({ selectedBateauId }: ArticlesCritiquesCardProps) => {
  const { articles, loading } = useInventaire();

  // Filtrer les articles du navire sélectionné et identifier ceux qui sont critiques
  const articlesCritiques = articles.filter(article => {
    if (!selectedBateauId || article.bateau_id !== selectedBateauId) {
      return false;
    }
    // Un article est critique si sa quantité est inférieure à 25% de la quantité max
    const pourcentage = (article.quantite / article.quantite_max) * 100;
    return pourcentage < 25;
  });

  if (loading) {
    return (
      <Card className="border-0 shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-medium flex items-center gap-2">
            <Package className="h-5 w-5 text-nautic-gold" />
            <span>Articles critiques</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8 text-gray-500">
            <Package className="h-12 w-12 mx-auto mb-4 opacity-50 animate-pulse" />
            <p className="text-sm">Chargement...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium flex items-center gap-2">
          <Package className="h-5 w-5 text-nautic-gold" />
          <span>Articles critiques</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {articlesCritiques.length > 0 ? (
          <div className="space-y-3">
            {articlesCritiques.map(article => {
              const pourcentage = Math.round((article.quantite / article.quantite_max) * 100);
              return (
                <div 
                  key={article.id} 
                  className="p-3 bg-red-50 rounded-lg border border-red-200"
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-medium text-sm text-red-900">{article.nom}</h4>
                      <p className="text-xs text-red-700 mt-1">
                        {article.categorie}
                        {article.sous_categorie && ` • ${article.sous_categorie}`}
                      </p>
                      <p className="text-xs text-red-600 mt-1">
                        Stock: {article.quantite} / {article.quantite_max} ({pourcentage}%)
                      </p>
                    </div>
                    <div>
                      <span className="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800">
                        Critique
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Package className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-sm">Aucun article en stock critique</p>
            {!selectedBateauId && (
              <p className="text-xs mt-1">Sélectionnez un navire pour voir l'inventaire</p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ArticlesCritiquesCard;
